import { apiFetch } from '@/api/client'

export const usersApi = {
  list: (workspaceId, params) => apiFetch(`workspaces/${workspaceId}/users`, { params }),
}
